import React, { useState } from 'react'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { RiErrorWarningLine } from 'react-icons/ri'
import { strongPasswordRegEx } from 'src/Pages/Auth/Register/PhoneNumberReg'
import { NOCWrapper, FormContainer } from './style'
import { ChangePasswordDto } from 'src/services/types'
import { useDispatch } from 'react-redux'
import { changePasswordAction } from 'src/redux/actions/profileAction'
import { useTypedSelector } from 'src/redux/root-reducer'
import { ModalTitleText, LabelText } from 'src/components/Global/Text/TitleText'
import useSnackbar from 'src/hooks/useSnackBar'

const PasswordSettings = () => {
  const [userData, setUserData] = useState<ChangePasswordDto>({
    old_password: '',
    new_password: '',
    new_password_confirmation: '',
  })
  const dispatch = useDispatch()
  const { old_password, new_password, new_password_confirmation } = userData
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...userData }
    newData[name] = value
    setUserData(newData)
  }
  const payload = {
    PasswordSettings: {
      ...userData,
    },
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (
      !old_password ||
      !new_password ||
      !new_password_confirmation ||
      new_password !== new_password_confirmation ||
      new_password.length <= 8 ||
      !strongPasswordRegEx.test(new_password)
    ) {
      setSubmitted(true)
      return
    }
    dispatch(changePasswordAction({ payload, onSuccess, onError }))
    setLoading(true)
  }
  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: error,
      severity: 'error',
    })
  }
  const Disabled = () => {
    if (
      !old_password ||
      !new_password ||
      !new_password_confirmation ||
      new_password !== new_password_confirmation ||
      new_password.length <= 8 ||
      !strongPasswordRegEx.test(new_password)
    ) {
      return 'blur'
    }
    return null
  }
  return (
    <FormContainer>
      <NOCWrapper onSubmit={handleSubmit}>
        <div>
          <ModalTitleText>Password Settings</ModalTitleText>
          <LabelText className="minus">
            Change your F&K Savings password.
          </LabelText>
          <div className="amount">
            <LabelText>Old Password</LabelText>
            <div
              className={
                'form-group' + (submitted && !old_password ? ' has-error' : '')
              }
            >
              <QuicksaveInput
                type="password"
                placeholder=""
                name="old_password"
                value={old_password}
                onChange={handleChange}
              />
              {submitted && !old_password && (
                <p className="error-text">new password is required</p>
              )}
              <RiErrorWarningLine className="error-icon" />
            </div>
          </div>
          <div className="amount">
            <LabelText>New Password</LabelText>
            <div
              className={
                'form-group' + (submitted && !new_password ? ' has-error' : '')
              }
            >
              <QuicksaveInput
                type="password"
                name="new_password"
                value={new_password}
                onChange={handleChange}
                placeholder=""
              />
              {(submitted && !new_password && (
                <p className="error-text">New Password is required</p>
              )) ||
                (submitted && !new_password && new_password.length <= 8 && (
                  <p className="error-text">
                    New Password should be greater than 7 characters
                  </p>
                )) ||
                (submitted && !strongPasswordRegEx.test(new_password) && (
                  <p className="error-text">Not a Strong passwordr</p>
                ))}
              <RiErrorWarningLine className="error-icon" />
            </div>
          </div>
          <div className="amount">
            <LabelText>Confirm New Password</LabelText>
            <div
              className={
                'form-group' +
                (submitted && !new_password_confirmation ? ' has-error' : '')
              }
            >
              <QuicksaveInput
                type="password"
                name="new_password_confirmation"
                value={new_password_confirmation}
                onChange={handleChange}
                placeholder=""
              />
              {(submitted && !new_password_confirmation && (
                <p className="error-text">New Pasnnewsword is required</p>
              )) ||
                (submitted &&
                  new_password_confirmation &&
                  new_password !== new_password_confirmation && (
                    <p className="error-text">Both passwords DO not match!</p>
                  ))}
              <RiErrorWarningLine className="error-icon" />
            </div>
          </div>
        </div>
        <div className="tops">
          <ModalButton>Update Password {loading && <Spinner />}</ModalButton>
        </div>
      </NOCWrapper>
    </FormContainer>
  )
}

export { PasswordSettings }
